import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const FilesFlashIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="8 8 16 16" className={classes.svg}>
      <g>
        <path d="M20.5 8H15c-.4 0-.777.156-1.083.463l-3.478 3.968c-.283.283-.439.66-.439 1.06V22.5c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5zm-6.514 1.9V13h-2.718l2.718-3.1zM21 22.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V14h3.986V9.003c.005 0 .01-.003.014-.003h5.5a.5.5 0 0 1 .5.5v13z" />
        <path d="M14.25 20h.693v-1.611h1.397v-.57h-1.397v-1.047h1.499v-.57H14.25zM16.796 16h.699v4h-.699z" />
      </g>
    </svg>
  ),
  displayName: 'FilesFlashIcon',
});

export default FilesFlashIcon;
